// Helpers de horarios y canchas que comparten las planillas en PDF (árbitros,
// micrófono) y el armado de turnos.

export const SIN_CANCHA = "__sin_cancha__";

const CANCHAS_EN_LETRAS = {
  1: "UNO",
  2: "DOS",
  3: "TRES",
  4: "CUATRO",
  5: "CINCO",
  6: "SEIS",
  7: "SIETE",
  8: "OCHO",
};

// "14:30" -> 870. null si el partido todavía no tiene hora cargada.
export const enMinutos = (hora) => {
  const m = /^(\d{1,2}):(\d{2})$/.exec(String(hora || "").trim());
  if (!m) return null;
  return Number(m[1]) * 60 + Number(m[2]);
};

// Un partido entra en las planillas en PDF solo si ya tiene cancha y horario: sin
// eso no hay dónde ni cuándo ubicarlo en la grilla.
export const estaProgramado = (match) => !!match.cancha && enMinutos(match.hora) != null;

export const claveDeCancha = (match) => (match.cancha ? String(match.cancha) : SIN_CANCHA);

export const nombreDeCancha = (clave) =>
  clave === SIN_CANCHA ? "SIN CANCHA ASIGNADA" : "CANCHA " + (CANCHAS_EN_LETRAS[clave] || clave);

// Comparador de partidos por hora; los que no tienen hora quedan al final.
export const porHora = (a, b) => {
  const ma = enMinutos(a.hora);
  const mb = enMinutos(b.hora);
  if (ma == null) return 1;
  if (mb == null) return -1;
  return ma - mb;
};

// [{ clave, titulo, partidos }] ordenado por número de cancha; los partidos sin
// cancha quedan al final, en su propio grupo.
export function agruparPorCancha(matches = []) {
  const grupos = new Map();
  matches.forEach((m) => {
    const clave = claveDeCancha(m);
    if (!grupos.has(clave)) grupos.set(clave, []);
    grupos.get(clave).push(m);
  });

  return [...grupos.entries()]
    .sort(([a], [b]) => {
      if (a === SIN_CANCHA) return 1;
      if (b === SIN_CANCHA) return -1;
      return Number(a) - Number(b);
    })
    .map(([clave, partidos]) => ({
      clave,
      titulo: nombreDeCancha(clave),
      partidos: [...partidos].sort(porHora),
    }));
}

// Comparador de partidos por cancha y, dentro de cada cancha, por hora. Los
// partidos sin cancha quedan al final; dentro del grupo, los sin hora al final.
export const porCanchaYHora = (a, b) => {
  const ca = claveDeCancha(a);
  const cb = claveDeCancha(b);
  if (ca !== cb) {
    if (ca === SIN_CANCHA) return 1;
    if (cb === SIN_CANCHA) return -1;
    return Number(ca) - Number(cb);
  }
  return porHora(a, b);
};
